import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateInstrumentTypeCommand extends ValueObject {

    public staticInstrumentTypeID: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public instrumentTypeName: string = "";
}